<form class="login-form" (submit)="onSubmit($event)">
  <dx-form [formData]="formData" [disabled]="loading">

    <dxi-form-item dataField="email" editorType="dxTextBox"
      [editorOptions]="{ stylingMode: 'filled', placeholder: 'Nome Utente' }">
      <dxi-form-validation-rule type="required" message="Il nome utente è richiesto"></dxi-form-validation-rule>
      <dxo-form-label [visible]="false"></dxo-form-label>
    </dxi-form-item>

    <dxi-form-item dataField="password" editorType="dxTextBox"
      [editorOptions]="{ stylingMode: 'filled', placeholder: 'Password', mode: 'password' }">
      <dxi-form-validation-rule type="required" message="La Password è richiesta"></dxi-form-validation-rule>
      <dxo-form-label [visible]="false"></dxo-form-label>
    </dxi-form-item>

    <dxi-form-item dataField="rememberMe" editorType="dxCheckBox"
      [editorOptions]="{ text: 'Ricordami', elementAttr: { class: 'form-text' } }">
      <dxo-form-label [visible]="false"></dxo-form-label>
    </dxi-form-item>

    <dxi-form-item itemType="button">
      <dxo-form-button-options width="100%" type="default" [useSubmitBehavior]="true" [template]="'signInTemplate'">
      </dxo-form-button-options>
    </dxi-form-item>

    <ng-container *dxTemplate="let item of 'signInTemplate'">
      <div>
        <span class="dx-button-text">
          @if (loading) {
            <dx-load-indicator width="24px" height="24px" [visible]="true"></dx-load-indicator>
          } @else {
            Accedi
          }
        </span>
      </div>
    </ng-container>

  </dx-form>
</form>
